import {Component, OnInit} from '@angular/core';
import {Constant} from '../../../global/util/Constant';
import {Document} from '../../../user/model/Document';
import {FormGroup} from '@angular/forms';
import HttpStatusCode from '../../../global/util/HttpStatusCode';
import {PersonService} from '../../../user/service/person.service';
import {TranslateService} from '@ngx-translate/core';
import {ApplicationService} from '../../../user/service/application.service';
import {PublicService} from '../../../user/service/public.service';
import {Person} from '../../../user/model/Person';
import {ActivatedRoute, Router} from '@angular/router';
import {GeolocationIofesign} from '../../../user/model/GeolocationIofesign';
import {TypeSignature} from '../../../global/util/TypeSignature';
import {Stamprubrictemporal} from '../../../user/model/Stamprubrictemporal';
import {LocalStorage} from '../../../global/util/LocalStorage';
import {StateSolcert} from '../../../global/util/validator/StateSolcert';

@Component({
  selector: 'app-welcome-to-sign',
  templateUrl: './welcome-to-sign.component.html',
  styleUrls: ['./welcome-to-sign.component.css']
})
export class WelcomeToSignComponent implements OnInit {
  public signatureForm: FormGroup;
  public loading: boolean;
  private hashIdentifier;
  public personId: number;
  public document: Document;
  public person: Person;
  public messageErrorRequest = '';
  private geolocation: GeolocationIofesign;
  private longitude = null;
  private latitude = null;
  private accuracy = null;
  public signatureTypeDescription = 'Firma gráfica';
  public hasIdentityValidation = false;
  public errorMessage: any;
  public documentSigned: boolean;
  public positionRubrics: any[] = [];
  public resourceList: any[] = [];
  public messageRequest: string;
  public stateDescription: string;
  public hasImagesDocument = false;
  // Persona validada segun el solcert.
  public isValidPerson = false;
  // Estado de la solcitud de validación de documentos.
  public stateIdSolcert: number;
  public hasPersonConfirmation: boolean;
  public needRubric = false;
  public invalidPersonConfirmation: boolean;
  public wrongRequestPersonSolcert = true;
  public wrongRequestPersonSolcert1 = false;
  public observation: string;
  public wrongRequestPerson = true;
  public wrongRequestDocument = true;
  public typeSignature = TypeSignature;

  constructor(private activatedRoute: ActivatedRoute,
              private personService: PersonService,
              private translate: TranslateService,
              private applicationService: ApplicationService,
              private publicService: PublicService,
              private route: Router) {
    localStorage.clear();
    this.receiveParams();
  }

  ngOnInit(): void {
    LocalStorage.removeItem('termConditionAccepted');
    this.loadPersonData(this.personId);
  }

  public receiveParams() {
    this.activatedRoute.params.subscribe(params => {
      this.hashIdentifier = params.hashIdentifier;
      this.personId = +params.personId;
    });
    this.getCurrentLocation();
  }

  private loadDocumentData(hashIdentifier: string) {
    this.loading = true;
    const urlDocument = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/hashIdentifier/', hashIdentifier, '/documents');
    this.personService.get(urlDocument).subscribe((next: Document) => {
      this.loading = false;
      this.document = next;
      this.hasIdentityValidation = next._more.hasIdentityValidation;
      this.buildSignatureTypeDescription(next._more.typeSignature);
      this.person.documentId = next.id;
      this.resourceList = this.document._more.resources;
      this.createEntities();
      this.hasImagesDocument = this.document._more.hasImagesDocument;
      this.needRubric = this.document._more.needRubric;
      this.isValidPerson = this.document._more.validPerson;
      this.stateIdSolcert = this.document._more.stateSolcert;
      this.hasPersonConfirmation = this.document._more.hasPersonConfirmation;
      this.observation = this.document._more.observationSolcert && !this.isInvalidPersonByValidityPeriod(this.document) ? this.translate.instant('LABEL.MOTIVE') + this.document._more.observationSolcert : '';
      this.stateDescription = StateSolcert.CREATE === this.stateIdSolcert ? this.translate.instant('LABEL.PENDING') : this.isInvalidPersonByValidityPeriod(this.document) ? this.translate.instant('MESSAGE.YOU-HAVE-EXCEEDED-THE-VALIDITY-TIME-LIMIT') : this.translate.instant('MESSAGE.REJECTED');
      this.messageRequest = 'Estado de validación del certificado de firma: <b>' + this.stateDescription + '</b><br>' + this.observation;
      if (this.isInvalidPersonByValidityPeriod(this.document)) {
        this.invalidPersonConfirmation = true;
      }
      if (StateSolcert.ATTEND === this.stateIdSolcert && !this.isInvalidPersonByValidityPeriod(this.document) || !this.stateIdSolcert) {
        this.wrongRequestPersonSolcert = false;
      }
      if (StateSolcert.CREATE === this.stateIdSolcert || this.isInvalidPersonByValidityPeriod(this.document)) {
        this.wrongRequestPersonSolcert1 = true;
      }
      if ((this.isCloudSignature || this.haveDocumentIntegrityToGraficSign) && this.needShowImages) {
        this.navigateRequestCertificate();
      }
      this.documentSigned = false;
      this.wrongRequestDocument = false;
      if (this.isCloudSignature) {
        this.verifyAcceptTermToSignCloud(next);
      }
    }, error => {
      this.loading = false;
      this.documentSigned = true;
      this.wrongRequestDocument = true;
      if (HttpStatusCode.FOUND === error.status) {
        this.messageErrorRequest = error.error.message;
        return;
      }
      this.messageErrorRequest = error.error.message;
    });
  }

  private loadPersonData(personId: number) {
    this.loading = true;
    this.documentSigned = false;
    const urlPerson = Constant.ROOT_API_V1.concat('/public/documents/')
      .concat(this.hashIdentifier)
      .concat('/people/').concat(String(personId));
    this.personService.get(urlPerson).subscribe((next: Person) => {
      this.loading = false;
      this.person = next;
      this.loadDocumentData(this.hashIdentifier);
      this.loadLogoEnterprise(next.enterpriseId);
      this.wrongRequestPerson = false;
    }, error => {
      this.loading = false;
      this.documentSigned = true;
      this.wrongRequestPerson = true;
      if (error.status) {
        if (HttpStatusCode.NOT_FOUND === error.status || HttpStatusCode.REQUEST_TIMEOUT === error.status) {
          this.messageErrorRequest = error.error.message;
        } else {
          this.messageErrorRequest = error.error.message;
        }
      }
    });
  }

  private getCurrentLocation() {
    this.applicationService.getIp().subscribe((value: any) => {
      localStorage.setItem('ip_address', value.ip);
    });
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.longitude = position.coords.longitude;
        this.latitude = position.coords.latitude;
        this.accuracy = position.coords.accuracy;
      }, error => {
        this.longitude = null;
        this.latitude = null;
        this.accuracy = null;
      });
    }
  }

  private loadLogoEnterprise(enterpriseId: number) {
    const url = Constant.ROOT_API_V1.concat('/public/enterprise/').concat(String(enterpriseId)).concat('/logo');
    this.publicService.get(url).subscribe(next => {
      if (next) {
        localStorage.setItem('enterpriseLogoBase64', next.data);
        localStorage.setItem('logoFileExtension', next.extension);
      }
    }, error => {
      console.log('Error no se pudo obtener el logo de la empresa.');
    });
  }

  private buildSignatureTypeDescription(typeSignature: number) {
    const signTypeDescription = typeSignature === TypeSignature.ELECTRONIC ? this.translate.instant('BUTTON.GRAPHICALLY-SIGN') : (typeSignature !== TypeSignature.ANYTHING ? this.translate.instant('BUTTON.DIGITALLY-SIGN') : this.translate.instant('BUTTON.REVIEW'));
    const message: any = this.translate.instant('MESSAGE.FALLOW-THE-STEPS');
    this.signatureTypeDescription = message.replaceAll('P_PARAM', signTypeDescription.toLowerCase());
    return this.signatureTypeDescription;
  }

  StartSigning() {
    this.person.documentId = this.document.id;
    switch (this.document._more.typeSignature) {
      case TypeSignature.ELECTRONIC:
        this.document._more.hasIdentityValidation ? this.navigateIdentityValidation() : this.navigateDocumentViewer();
        break;
      case TypeSignature.DIGITAL:
        this.navigateDocumentViewer();
        break;
      case TypeSignature.CLOUD:
        (this.isCloudSignature || this.haveDocumentIntegrityToGraficSign) && this.needShowImages ? this.navigateRequestCertificate() : this.navigatePersonDataConfirmation();
        break;
      case TypeSignature.REMOTE:
        this.navigateDocumentViewer();
        break;
      case TypeSignature.ANYTHING:
        this.navigateDocumentReviewer();
        break;
    }
  }

  private createEntities() {
    if (this.document._more.positions) {
      this.positionRubrics = this.resourceList.map(value => {
        const position = this.document._more.positions;
        const positionSplitted = position.split(',', 6);
        const positionRubricInfo: Stamprubrictemporal = {
          resourceId: value.id,
          documentId: value.documentId,
          positionX: Number(positionSplitted[0]),
          positionY: Number(positionSplitted[1]),
          positionXf: Number(positionSplitted[2]),
          positionYf: Number(positionSplitted[3]),
          pageStamp: Number(positionSplitted[4]),
          page: Number(positionSplitted[5]),
          signaturedescriptionIds: null,
        };
        return positionRubricInfo;
      });
      LocalStorage.setItem('positionRubrics', this.positionRubrics);
    }
  }

  /**
   * Evalua si la persona ha sido evaluada y rechazada por los operadores del solcert.
   */
  public isInvalidPersonByValidityPeriod(document: Document) {
    return !document._more.validPerson && document._more.stateSolcert === StateSolcert.ATTEND;
  }

  navigateDocumentViewer() {
    this.navigateNextScreen(this.hashIdentifier, this.personId, 'viewer');
  }

  navigatePersonDataConfirmation() {
    this.navigateNextScreen(this.hashIdentifier, this.personId, 'confirmation');
  }

  navigateIdentityValidation() {
    this.navigateNextScreen(this.hashIdentifier, this.personId, 'identity-validation');
  }

  private navigateRequestCertificate() {
    this.navigateNextScreen(this.hashIdentifier, this.personId, 'request-certificate');
  }

  private navigateDocumentReviewer() {
    this.navigateNextScreen(this.hashIdentifier, this.personId, 'review-document');
  }

  verifyAcceptTermToSignCloud(document: any) {
    this.publicService.verifyAcceptTerm(document._more.uanatacaRequestId).subscribe((next: any) => {
      if (Boolean(next.acceptTermCondition === 'true')) {
        LocalStorage.setItem('termConditionAccepted', 'true');
      } else {
        LocalStorage.setItem('termConditionAccepted', 'false');
      }
    }, error => {
      LocalStorage.setItem('termConditionAccepted', 'false');
    });
  }


  /**
   * Este método recibe paramatros para navegar entre pantallas.
   * @param hashIdentifier :
   * @param personId :
   * @param nameUrl :
   * @private
   */
  private navigateNextScreen(hashIdentifier: any, personId: any, nameUrl: any) {
    this.route.navigate(['document/' + hashIdentifier + '/people/' + personId + '/' + nameUrl + '/'], {
      state: {
        document: this.document,
        person: this.person
      }
    }).then();
  }

  /**
   * Valida si necesita mostrar los contenedores de las imagenes de documento.
   */
  get needShowImages(): boolean {
    if (!this.hasPersonConfirmation) {
      return true;
    }
    if (this.stateIdSolcert) {
      return StateSolcert.REFUSED === this.stateIdSolcert || !this.hasImagesDocument;
    }
    return !this.hasImagesDocument;
  }

  get isCloudSignature(): boolean {
    return TypeSignature.CLOUD === this.document._more.typeSignature;
  }

  /**
   * Verifica si esta habilitado documentIntegrity para la firma gráfica con integridad del documento.
   */
  get haveDocumentIntegrityToGraficSign() {
    return this.document._more.documentIntegrity;
  }

  get isTypeSignatureAnyThing() {
    return this.document._more.typeSignature === TypeSignature.ANYTHING;
  }
}
